'use client';

import { c as _c } from "react/compiler-runtime";
import React from 'react';
import classNames from 'classnames';
import { useInstantSearch } from 'react-instantsearch';
const SectionButtons = t0 => {
  const $ = _c(6);
  const {
    title,
    onClick,
    active: t1,
    countOverride: t2
  } = t0;
  const active = t1 === undefined ? false : t1;
  const countOverride = t2 === undefined ? null : t2;
  const {
    results
  } = useInstantSearch();
  const count = countOverride ?? results?.nbHits ?? "";
  let t3;
  if ($[0] !== active) {
    t3 = classNames("w-full bg-white text-center md:text-left text-base", {
      "font-bold": active
    });
    $[0] = active;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const t4 = `${title} ${`(${count})` ?? ""}`;
  let t5;
  if ($[2] !== onClick || $[3] !== t3 || $[4] !== t4) {
    t5 = <div className="px-0 py-1.5 max-[767px]:p-0 hover:text-brand"><button type="button" className={t3} onClick={onClick}>{t4}</button></div>;
    $[2] = onClick;
    $[3] = t3;
    $[4] = t4;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  return t5;
};
export default SectionButtons;